export const getConfig = () => ({
  defaultVisibleSeekerCount: 25,
  visibleSeekerCountIncrement: 10,
  maxVisibleSeekerCount: 500,
});
